import { DataTable, Dialog, Loader } from "@/components";
import { Button } from "@/components/ui";
import useNewsMedia from "./useJobPosting";
import { Outlet } from "react-router-dom";
import { useState } from "react";

const tabs = ["Ostwal", "MBAPL", "KPL"];

const NewsMedia = () => {

  const [activeTab, setActiveTab] = useState("Ostwal");
  const {
    onAdd,
    columns,
    openDialog,
    setOpenDialog,
    deletedRow,
    isDeletePending,
    onDeleteConfirm,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    jobPostingList,
    isJobPostingLoading,
  } = useNewsMedia(activeTab);

  

  return (
    <div className="p-4 md:p-6">
      {/* Tabs */}
            <div className="flex items-center gap-4 mb-4 border-b pb-2">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  type="button"
                  onClick={() => setActiveTab(tab)}
                  className={`px-4 py-2 rounded-t-md font-medium transition-colors duration-150 cursor-pointer ${
                    activeTab === tab
                      ? "text-[#E2544B] border-b-2 border-[#E2544B]"
                      : "text-gray-500 hover:text-[#E2544B]"
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-end justify-end w-full">
          <Button
            onClick={() => onAdd(activeTab)}
            className="px-4"
            disabled={isJobPostingLoading}
          >
            + Add
          </Button>
        </div>
      </div>

      {isJobPostingLoading ? (
        <Loader />
      ) : (
        <DataTable
          columns={columns}
          data={(jobPostingList?.data?.items?.[0]?.records || [])?.sort(
            (a: any, b: any) =>
              new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
          )}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalPages={Math.ceil(
            jobPostingList?.data?.items?.[0]?.pagination?.totalRecords /
              pageSize
          )}
          totalRecords={
            jobPostingList?.data?.items?.[0]?.pagination?.totalRecords
          }
          serviceSidePagination={true}
        />
      )}

      {openDialog && (
        <Dialog
          open={openDialog}
          setOpen={setOpenDialog}
          title={
            <div className="text-2xl font-bold text-primary">
              {"Confirmation"}
              <div className="h-1 w-[30%] bg-primary rounded-full" />
            </div>
          }
          saveText="Delete"
          saveBtnClassName="bg-red-500 text-white hover:bg-red-500 hover:text-white"
          isLoading={isDeletePending}
          onSave={onDeleteConfirm}
        >
          <p className="text-sm">
            Are you sure you want to delete this Job Posting with Role -
            <span className="font-bold text-primary">{deletedRow?.jobRole}</span>?
          </p>
        </Dialog>
      )}
      <Outlet />
    </div>
  );
};

export default NewsMedia;
